<template>
  <ppt-modal class="combos-to-add-modal">
    <header slot="header">
      <h4 class="modal-title">Select suits</h4>
      <button class="close" data-dismiss="modal"><span>&times;</span></button>
      <button class="btn btn-default" v-on:click="clear()">Clear</button>
      <button class="btn btn-default" v-on:click="selectAll()">Select all</button>
    </header>
    <section slot="body">
      <p>When you click to add hands on the grid, these are the combos that will be added.</p>
      <table>
        <tr v-for="row in suitsGrid">
          <td
            v-for="suits in row"
            v-bind:key="suits"
            v-bind:class="{ 'selected': isComboInCombosToAdd(suits) }"
            v-on:click="toggleCombo(suits)"
          >
            <span v-html="getHTMLForSuitIcons(suits)"></span>
            <input
              type="checkbox"
              v-bind:checked="isComboInCombosToAdd(suits)"
            >
          </td>
        </tr>
      </table>
      <hr>
      <p>Example: If only club-club is selected...</p>
      <ul>
        <li>...and you click AKs, only AcKc will be added.</li>
        <li>...and you click AKo, you will get an error, because there is no club-club combo of AKo.</li>
        <li>...and you click AA, you will get an error, because there is no club-club combo of AA.</li>
      </ul>
      <p>Use case: If the board is Qc6c4s and you want to click and drag to add a bunch of club-club combos, because club-club combos make a flush draw.</p>
    </section>
  </ppt-modal>
</template>

<script>
import PPTModal from '@/components/utilities/modal';
import utilities from '@/services/utilities/utilities';
import constants from '@/services/constants';

export default {
  name: 'combos-to-add-modal',
  components: {
    'ppt-modal': PPTModal,
  },
  props: ['combosToAdd'],
  data: function () {
    return {
      suitsGrid: [
        ['cc', 'cs', 'ch', 'cd'],
        ['sc', 'ss', 'sh', 'sd'],
        ['hc', 'hs', 'hh', 'hd'],
        ['dc', 'ds', 'dh', 'dd']
      ],
    };
  },
  methods: {
    getHTMLForSuitIcons: function (suits) {
      return utilities.general.getHTMLForSuitIcons(suits);
    },
    isComboInCombosToAdd: function (combo) {
      return this.combosToAdd.includes(combo);
    },
    toggleCombo: function (combo) {
      if (this.isComboInCombosToAdd(combo)) {
        this.$emit('removeComboFromCombosToAdd', combo);
      } else {
        this.$emit('addComboToCombosToAdd', combo);
      }
    },
    selectAll: function () {
      this.clear();
      constants.combos.forEach(function (combo) {
        this.$emit('addComboToCombosToAdd', combo);
      }, this);
    },
    clear: function () {
      constants.combos.forEach(function (combo) {
        this.$emit('removeComboFromCombosToAdd', combo);
      }, this);
    },
  }
};
</script>

<style lang="scss" scoped>
  @import "node_modules/bootstrap-sass/assets/stylesheets/bootstrap/variables";
  @import "src/assets/mixins";

  .modal-header {
    .modal-title {
      float: left;
      position: relative;
      top: 5px;
    }

    button {
      float: right;
      margin-right: 10px;
    }

    .close {
      margin-left: 5px;
      position: relative;
      top: 5px;
    }
  }

  table {
    border-spacing: 5px;
    border-collapse: separate;
    max-width: 100%;

    td {
      text-align: center;
      vertical-align: middle;
      border-radius: 5px;
      font-size: 22px;
      width: 60px;
      height: 60px;
      border: 1px solid lightgray;
      cursor: pointer;

      @include noselect();

      &.selected {
        background: lighten($gray-base, 72%);;
      }

      input[type="checkbox"] {
        display: block;
        margin: 0 auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/modals/combos-to-add-modal.vue